/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:42:05
 */
const s = {
    ballDistance: 28.69,
    diameter: 14.83,
    numRows: 9,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [319.0475823613252, 364.64237466948674, 318.9464318208531, 362.2885561239519, 320.35689762196745, 362.3783951888319, 320.50025180099937, 317.3956582857196],
        1: [319.79383677933566, 364.64687533659986, 320.2550814784826, 362.409526876617, 362.4663486681278, 364.034166737667, 317.39197429876907, 320.70717850280084],
        2: [319.893458831331, 319.41674458215294, 320.42032077508196, 320.5623865214326, 320.51019861682965, 364.16126909410525, 320.99777938306545, 319.41658162038914],
        3: [364.01286291433775, 364.58277358960123, 362.69927981299054, 363.94442287918514, 364.568743211294, 363.23933730679147, 319.5490125597347, 319.6515835618147],
        4: [364.496824193274, 319.746013279713, 362.0893180552124, 364.41388389376135, 319.8531552500867, 364.68070006907107, 318.94037148671777, 321.2065432183327],
        5: [362.31195840040283, 317.51026297012055, 360.81911372113404, 319.6612302786013, 364.4943798958634, 362.23112519749714, 362.98799738811573, 318.22043539040305],
        6: [318.02557930302453, 319.6132658783552, 319.09953251479016, 363.09279612002985, 318.0099611285603, 364.19434615891305, 364.1347042950337, 317.3362362861113],
        7: [318.67797778547805, 317.4264913006056, 361.1489807671207, 361.19398999373806, 319.628494886177, 364.3050235655568, 317.6721506648912, 363.4542222430134],
        8: [362.850335935653, 361.09673142675985, 317.414877181577, 362.53153114822055, 362.3810429949202, 319.9267010398241, 318.67865243425024, 364.5953461825523],
        9: [361.08652995049954, 361.0858294644629, 362.1978810080391, 319.9395443757222, 361.5051817514281, 319.6439695035837, 318.0509884825682, 362.23532277959464],
        10: []
    }
};
export {s as default};
